import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import moment from "moment";
import Datetime from "react-datetime";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { NavLink, useHistory } from "react-router-dom";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function LogsHistory() {
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const textareaRef = useRef(null);

  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["admin.logs.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const textarea = document.querySelector('textarea[name="logs"]');
      if (textarea) {
        textarea.scrollTop = textarea.scrollHeight;
      }
    }, 0);
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  const fetchData = (lines = 2000) => {
    setShowLoading(true);

    fetch(`/api/v1/log/history`, {
      method: "GET",
      headers: {
        sessionId: sessionStorage.getItem("sessionId"),
        selectedDate: selectedDate,
        mode: "manual",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Status ${response.status}`);
        }
        return response.text();
      })
      .then((textContent) => {
        setShowLoading(false);
        if (!textContent.trim()) {
          setData("No logs available for the selected date.");
        } else {
          const header =
            `=== Displaying the last ${lines} lines of the most recent log file ===\n` +
            `(The complete file may contain many more lines)\n` +
            `------------------------------------------------------------\n\n`;

          setData(header + textContent);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.error(err);
        setData("");
      });
  };

  const handleDate = (date) => {
    setSelectedDate(date);
  };

  const isValidDate = (current) => {
    return current.isBefore(moment().add(1, "days"), "day");
  };

  const formatTimestamp = () => {
    // Convert selectedDate to a Moment object if it is not already
    const date = moment(selectedDate).isValid()
      ? moment(selectedDate).toDate()
      : new Date(selectedDate);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}${month}${day}`;
  };

  const handleDownload = async () => {
    try {
      const response = await fetch("/api/v1/log/download", {
        headers: {
          sessionId: sessionStorage.getItem("sessionId"),
          selectedDate: selectedDate,
          mode: "manual",
        },
      });

      if (response.status == 404) {
        throw new Error("No Log Found");
      } else if (response.status != 200) {
        throw new Error("An error occurred while downloading the logs.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `logs_${formatTimestamp()}.txt`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert(error);
    }
  };

  return (
    <>
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Logs</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Card>
              <CardBody>
                <FormGroup>
                  <label>Log Date</label>
                  <Datetime
                    inputProps={{
                      className: "form-control",
                    }}
                    onChange={handleDate}
                    timeFormat={false}
                    value={selectedDate}
                    isValidDate={isValidDate}
                    dateFormat={"MMMM DD, yyyy"}
                  />
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          <Col sm="8">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="info"
                onClick={() => fetchData()}
                direction="down"
                style={{ marginRight: "10px" }}
              >
                Refresh
              </Button>
              <Button
                color="info"
                onClick={() => handleDownload()}
                direction="down"
                style={{ marginRight: "10px" }}
              >
                Download Logs
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              type="textarea"
              name="logs"
              ref={textareaRef}
              style={{ paddingLeft: "20px", cursor: "default" }}
              rows="20"
              readOnly
              value={data}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LogsHistory;
